import {getExternalLink, isExternal, isRegistrationWithCustomDates} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {getEvent} from '../../../selectors/event'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {SecondaryRsvpButtonOwnProps, SecondaryRsvpButtonRuntimeProps} from './interfaces'
import {SecondaryRsvpButton as Presentation} from './secondary-rsvp-button'

const mapRuntime = ({state}: DetailsPageAppProps): SecondaryRsvpButtonRuntimeProps => {
  const event = getEvent(state)

  return {
    url: getExternalLink(event),
    isExternalLink: isExternal(event),
    registrationWithCustomDates: isRegistrationWithCustomDates(event),
    eventId: event.id,
  }
}
export const SecondaryRsvpButton = withTranslation()(
  connect<SecondaryRsvpButtonOwnProps, SecondaryRsvpButtonRuntimeProps>(mapRuntime)(Presentation),
)
